/* tslint:disable */
/* eslint-disable */
/**
 * api-docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const SortType = {
    Asc: 'ASC',
    Desc: 'DESC',
};
export function SortTypeFromJSON(json) {
    return SortTypeFromJSONTyped(json, false);
}
export function SortTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function SortTypeToJSON(value) {
    return value;
}
//# sourceMappingURL=SortType.js.map